import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

export default function QRModal({ open, onOpenChange, value }) {
  const ref = useRef(null);

  const download = () => {
    const canvas = ref.current?.querySelector("canvas");
    if (!canvas) return;
    const link = document.createElement("a");
    link.download = "pixelvault-qr.png";
    link.href = canvas.toDataURL("image/png");
    link.click();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm" data-testid="qr-modal">
        <DialogHeader>
          <DialogTitle className="font-heading">Scan to open</DialogTitle>
          <DialogDescription>Scan this QR code to open the image link on another device.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center gap-5 py-4">
          <div ref={ref} className="p-4 bg-white rounded-xl border border-border">
            <QRCodeCanvas value={value || ""} size={200} level="M" includeMargin={false} />
          </div>
          <p className="text-xs text-muted-foreground font-mono break-all text-center max-w-full px-2">{value}</p>
          <Button onClick={download} data-testid="qr-download-btn" variant="outline" className="w-full">
            <Download className="h-4 w-4 mr-2" /> Download QR
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
